import { render, staticRenderFns } from "./order-editor.vue?vue&type=template&id=d3120838"
import script from "./order-editor.vue?vue&type=script&lang=ts"
export * from "./order-editor.vue?vue&type=script&lang=ts"
import style0 from "./order-editor.vue?vue&type=style&index=0&id=d3120838&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports